import { c as _c } from "react/compiler-runtime";
// Third Party
import * as React from 'react';
import debounce from 'lodash/debounce';

// Utils
import { labels } from '@utils/constants';
import { extractFirstPhraseBeforeComma } from '../../utils/extract-first-phrase-before-comma';
import { useLazyQuery } from '@apollo/client/react';
import { PlaceTypeFilter, PlacesAutocompleteDocument } from '@gql';

// UI
import { SearchSelectAutocomplete } from '@components/form/select-autocomplete/search-select-autocomplete';
import { IDropdownOption } from '@components/dropdown-option-list';
export enum PlacesSelectAutocompleteFilters {
  ALL = 'ALL',
  ADDRESS = 'ADDRESS',
  ESTABLISHMENT = 'ESTABLISHMENT',
  GEOCODE = 'GEOCODE',
  REGIONS = 'REGIONS',
}
export type IPlacesSelectAutocompleteOption = IDropdownOption<unknown>;
export interface IPlacesSelectAutocompleteProps {
  /** Custom content to place in the left side */
  leftContent?: React.ReactNode;
  /* Indicate if the label text */
  label?: string;
  /* Indicate if the field is invalid */
  isInvalid?: boolean;
  /* Indicate if the field has a border */
  hasBorder?: boolean;
  /** Custom content to place in the right side */
  rightContent?: React.ReactNode;
  /** Define the name of the input element */
  name: string;
  /** Defines the label to be displayed when there are no results */
  noResultsLabel: string;
  /** Define the placeholder of the input element */
  placeholder: string;
  /* Indicate if the label should be visible */
  showLabel?: boolean;
  /** Define if label is left aligned */
  labelLeftAligned?: boolean;
  /** Function to be executed when changing the selected value */
  onChange?: (name: string, value: IPlacesSelectAutocompleteOption | null) => void;
  /** Filter places by type */
  placesFilter?: PlacesSelectAutocompleteFilters;
  initialValue?: IPlacesSelectAutocompleteOption | null;
}
export const PlacesSelectAutocomplete: React.FC<IPlacesSelectAutocompleteProps> = t0 => {
  const $ = _c(30);
  const {
    label,
    name,
    placeholder,
    noResultsLabel,
    leftContent,
    rightContent,
    showLabel,
    onChange,
    labelLeftAligned: t1,
    isInvalid: t2,
    hasBorder: t3,
    placesFilter: t4,
    initialValue: t5
  } = t0;
  const labelLeftAligned = t1 === undefined ? false : t1;
  const isInvalid = t2 === undefined ? false : t2;
  const hasBorder = t3 === undefined ? true : t3;
  const placesFilter = t4 === undefined ? PlacesSelectAutocompleteFilters.ALL : t4;
  const initialValue = t5 === undefined ? null : t5;
  let t6;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = [];
    $[0] = t6;
  } else {
    t6 = $[0];
  }
  const [options, setOptions] = React.useState(t6);
  const [value, setValue] = React.useState(initialValue);
  const [placesAutocompleteQuery, t7] = useLazyQuery(PlacesAutocompleteDocument);
  const {
    data
  } = t7;
  let t8;
  if ($[1] !== onChange) {
    t8 = (name_0, value_0) => {
      setValue({
        label: extractFirstPhraseBeforeComma(value_0?.label || ""),
        leftContent: value_0?.leftContent,
        value: value_0?.value || ""
      });
      onChange?.(name_0, value_0);
    };
    $[1] = onChange;
    $[2] = t8;
  } else {
    t8 = $[2];
  }
  const onSelect = t8;
  let t9;
  if ($[3] !== placesAutocompleteQuery || $[4] !== placesFilter) {
    t9 = debounce(async value_1 => {
      placesAutocompleteQuery({
        variables: {
          query: value_1,
          type: filterMapper(placesFilter)
        }
      });
    }, 225);
    $[3] = placesAutocompleteQuery;
    $[4] = placesFilter;
    $[5] = t9;
  } else {
    t9 = $[5];
  }
  const debouncedonInputChange = t9;
  let t10;
  if ($[6] !== debouncedonInputChange) {
    t10 = event => {
      if (event.target.value) {
        debouncedonInputChange(event.target.value);
      }
    };
    $[6] = debouncedonInputChange;
    $[7] = t10;
  } else {
    t10 = $[7];
  }
  const onInputChange = t10;
  let t11;
  if ($[8] !== data) {
    t11 = () => {
      if (data?.placesAutocomplete) {
        setOptions(data.placesAutocomplete.map(_temp));
      }
    };
    $[8] = data;
    $[9] = t11;
  } else {
    t11 = $[9];
  }
  let t12;
  if ($[10] !== data || $[11] !== value) {
    t12 = [data, value];
    $[10] = data;
    $[11] = value;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  React.useEffect(t11, t12);
  const t13 = label || "";
  let t14;
  if ($[13] !== t13) {
    t14 = extractFirstPhraseBeforeComma(t13);
    $[13] = t13;
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  const t15 = data ? noResultsLabel : labels.loading;
  let t16;
  if ($[15] !== hasBorder || $[16] !== isInvalid || $[17] !== labelLeftAligned || $[18] !== leftContent || $[19] !== name || $[20] !== onInputChange || $[21] !== onSelect || $[22] !== options || $[23] !== placeholder || $[24] !== rightContent || $[25] !== showLabel || $[26] !== t14 || $[27] !== t15 || $[28] !== value) {
    t16 = <SearchSelectAutocomplete isInvalid={isInvalid} hasBorder={hasBorder} label={t14} showLabel={showLabel} leftContent={leftContent} rightContent={rightContent} name={name} noResultsLabel={t15} options={options} placeholder={placeholder} value={value} onChange={onSelect} onInputChange={onInputChange} labelLeftAligned={labelLeftAligned} />;
    $[15] = hasBorder;
    $[16] = isInvalid;
    $[17] = labelLeftAligned;
    $[18] = leftContent;
    $[19] = name;
    $[20] = onInputChange;
    $[21] = onSelect;
    $[22] = options;
    $[23] = placeholder;
    $[24] = rightContent;
    $[25] = showLabel;
    $[26] = t14;
    $[27] = t15;
    $[28] = value;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  return t16;
};
const filterMapper = (filter: PlacesSelectAutocompleteFilters): PlaceTypeFilter => {
  switch (filter) {
    case PlacesSelectAutocompleteFilters.ALL:
      return PlaceTypeFilter.All;
    case PlacesSelectAutocompleteFilters.ADDRESS:
      return PlaceTypeFilter.Address;
    case PlacesSelectAutocompleteFilters.ESTABLISHMENT:
      return PlaceTypeFilter.Establishment;
    case PlacesSelectAutocompleteFilters.GEOCODE:
      return PlaceTypeFilter.Geocode;
    case PlacesSelectAutocompleteFilters.REGIONS:
      return PlaceTypeFilter.Regions;
  }
};
function _temp(place) {
  return {
    label: place.name,
    value: place.id
  };
}